import { render, staticRenderFns } from "./EstablishmentModal.vue?vue&type=template&id=6005c672&scoped=true&lang=html&"
import script from "./EstablishmentModal.vue?vue&type=script&lang=js&"
export * from "./EstablishmentModal.vue?vue&type=script&lang=js&"
import style0 from "./EstablishmentModal.vue?vue&type=style&index=0&id=6005c672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6005c672",
  null
  
)

component.options.__file = "EstablishmentModal.vue"
export default component.exports